<template>
 <ModalConsulte ref="modalRef" :hide-footer="false" modalWidth="600px !important">
  <template #header>
   <h4 class="modal-title">Renovação de Empréstimo</h4>
  </template>
  <template #content>
   <div class="row g-3">
    <div class="col-md-6">
     <label class="form-label" for="campo-dataEmprestimo-58bb">Data de Renovação</label>
     <input v-model="form.dataEmprestimo" type="date" class="form-control" @change="recalcularVencimento" id="campo-dataEmprestimo-58bb" />
    </div>
    <div class="col-md-6">
     <label class="form-label" for="campo-dataVencimento-58bb">Data de Vencimento</label>
     <input v-model="form.dataVencimento" type="date" class="form-control" readonly id="campo-dataVencimento-58bb" />
    </div>
   </div>
   <div v-if="mensagemErro" class="alert alert-danger mt-3 mb-0">
    {{ mensagemErro }}
   </div>
  </template>
  <template #actions>
   <button type="button" class="btn btn-light" @click="close">Cancelar</button>
   <button v-if="permissaoTela.alterar" type="button" class="btn btn-primary" :disabled="salvando" @click="salvar">
    {{ salvando ? "Salvando..." : "OK" }}
   </button>
  </template>
 </ModalConsulte>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalConsulte from "@/components/modal/ModalConsulte.vue";
import { BibEmprestimoModel } from "@/models/biblioteca/bibemprestimo/bibemprestimo.model";
import BibEmprestimoService from "@/services/biblioteca/bibemprestimo/bibemprestimo.service";
import BibTipoUsuarioService from "@/services/biblioteca/bibtipousuario/bibtipousuario.service";
import { addBusinessDaysFromLoan, formatDateInput } from "./utils";
import {
 PERMISSAO_TELA_INJECT_KEY,
 permissaoTelaLiberada,
} from "@/composables/usePermissaoTela/usePermissaoTela";

export default defineComponent({
 name: "ModalRenovacaoEmprestimo",
 components: { ModalConsulte },
 emits: ["saved"],
 inject: {
  // Permissão da tela de empréstimo que abriu o modal.
  permissaoTela: {
   from: PERMISSAO_TELA_INJECT_KEY,
   default: () => permissaoTelaLiberada(),
  },
 },
 data() {
  return {
   salvando: false,
   mensagemErro: "",
   model: new BibEmprestimoModel() as BibEmprestimoModel,
   form: {
    dataEmprestimo: "",
    dataVencimento: "",
   },
  };
 },
 methods: {
  async open(row: BibEmprestimoModel) {
   this.model = { ...new BibEmprestimoModel(), ...row };
   const bibTipoUsuarioIdRota = Number(this.$route.params.bibTipoUsuarioId || 0);
   this.model.bibTipoUsuarioId = Number(this.model.bibTipoUsuarioId || bibTipoUsuarioIdRota || 0);
   await this.carregarParametrosTipoUsuario(this.model.bibTipoUsuarioId);
   this.form.dataEmprestimo = formatDateInput(new Date());
   this.form.dataVencimento = addBusinessDaysFromLoan(this.form.dataEmprestimo, this.getPrazoEmprestimo());
   this.mensagemErro = "";
   (this.$refs.modalRef as any)?.open();
  },
  close() {
   (this.$refs.modalRef as any)?.close();
  },
  recalcularVencimento() {
   this.form.dataVencimento = addBusinessDaysFromLoan(this.form.dataEmprestimo, this.getPrazoEmprestimo());
  },
  getPrazoEmprestimo() {
   const prazo = Number(this.model.bibTipoUsuario?.prazoEmprestimo ?? this.model.prazoEmprestimo ?? 0);
   return Number.isFinite(prazo) && prazo > 0 ? prazo : 15;
  },
  async carregarParametrosTipoUsuario(bibTipoUsuarioIdRaw?: number | string | null) {
   const bibTipoUsuarioId = Number(bibTipoUsuarioIdRaw ?? this.model.bibTipoUsuarioId ?? 0);
   if (!bibTipoUsuarioId) {
    this.model.bibTipoUsuario = null;
    this.model.prazoEmprestimo = 0;
    this.model.moraAtraso = 0;
    return;
   }

   if (Number(this.model.bibTipoUsuario?.bibTipoUsuarioId || 0) === bibTipoUsuarioId) {
    return;
   }

   try {
    const tipoUsuario = await BibTipoUsuarioService.get(bibTipoUsuarioId);
    this.model.bibTipoUsuario = tipoUsuario;
    this.model.prazoEmprestimo = Number(tipoUsuario?.prazoEmprestimo ?? 0);
    this.model.moraAtraso = Number(tipoUsuario?.moraAtraso ?? 0);
   } catch (error) {
    this.model.bibTipoUsuario = null;
    this.model.prazoEmprestimo = 0;
    this.model.moraAtraso = 0;
    console.error("Erro ao carregar parâmetros do tipo de usuário:", error);
   }
  },
  async salvar() {
   this.mensagemErro = "";

   if (!this.form.dataEmprestimo) {
    this.mensagemErro = "Informe a data de renovação.";
    return;
   }

   const payload: BibEmprestimoModel = {
    ...this.model,
    dataEmprestimo: this.form.dataEmprestimo as unknown as Date,
    dataVencimento: this.form.dataVencimento as unknown as Date,
    renovacoes: 1,
   };

   this.salvando = true;
   try {
    await BibEmprestimoService.inserirAtualizar(payload);
    this.close();
    this.$emit("saved");
   } catch (error) {
    this.mensagemErro = "Ocorreu um erro ao salvar a renovação.";
    console.error("Erro ao salvar renovação:", error);
   } finally {
    this.salvando = false;
   }
  },
 },
});
</script>
